import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import Modal from './index'
import Button from '../../baseComponent/button'
import Icon from '../icon'
import './modalConfirm.less'

const ModalConfirm = ({ title, content, visible, onOk, onCancel, icon, footer, hiddenOk, hiddenCancel, okText, ...OtherProps }) => {
  const [_visible, set_Visible] = useState(visible)
  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    const flag = await onOk?.()
    if (flag === false) {
      return
    }
    set_Visible(false)
  }
  return (<Modal hiddenCloseIcon hiddenFooter visible={_visible} onVisibleChange={e => set_Visible(e)} size="mn-modal-confirm" {...OtherProps}>
    <div className="mn-modal-confirm-title">{icon || <Icon type="m-zhuyi_tianchong" />}{title}</div>
    <div className="mn-modal-confirm-content">{content}</div>
    <div className="mn-modal-confirm-footer">
      {footer || <>
        {hiddenCancel ? null : <Button type="normal" onClick={_cancel} width={62}>取消</Button>}
        {hiddenOk ? null : <Button type="primary" style={{ marginLeft: 8, }} onClick={_ok}>{okText || '确定'}</Button>}
      </>}
    </div>
  </Modal>)
}

ModalConfirm.show = (props) => {
  const div = document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<ModalConfirm {...props} visible container={div} />, div)
  })
}

export default ModalConfirm
